import {
  createStore, applyMiddleware, combineReducers,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import * as reducers from '../reducers';


let middleware = applyMiddleware(thunk);
if (process.env.REACT_APP_NODE_ENV !== 'production') {
  middleware = composeWithDevTools(middleware);
}


const appReducer = combineReducers({ ...reducers });

const rootReducer = (state, action) => {
  let nextState = state;
  console.log('action', action.type);
  if (action.type === 'USER_LOGOUT') {
    nextState = undefined;
  }
  return appReducer(nextState, action);
};

const store = createStore(rootReducer, middleware);

export default store;
